import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="legal-page" data-testid="privacy-page">
      <Link to="/" className="ghost-link" style={{ display: "inline-block", marginBottom: 40 }}>Back to Pord.</Link>

      <h1 className="page-title" style={{ fontSize: "clamp(1.8rem,5vw,2.8rem)", marginBottom: 8 }}>Privacy Policy & Disclaimer</h1>
      <p className="muted-caption">Effective: April 11, 2026 | Last updated: April 11, 2026</p>

      <h2>Part 1 — Disclaimer</h2>

      <h3>1.1 Not Investment Advice</h3>
      <p>Pord. is an educational platform. Nothing on this website — including the "EXHALE" and "How do you feel" sections, simulations, copy, modules, visuals, and any current or future feature — constitutes investment advice, financial advice, tax advice, legal advice, or a recommendation to buy, sell, hold, or otherwise transact in any security, fund, asset class, or financial instrument.</p>
      <p>The capsule experience is a hypothetical simulation based on historical market events. It does not analyze or evaluate users' actual portfolio, holdings, investment strategy, financial condition, or expected future returns.</p>
      <p>Any historical data referenced — including market drawdowns, S&P 500 returns, recovery periods, or topics related to behavioral finance — is provided solely for educational context. Past performance does not guarantee future results.</p>

      <h3>1.2 No Fiduciary or Advisory Relationship</h3>
      <p>Using this website, completing the Capsule Experience, joining the waitlist, or submitting your email address does not create a fiduciary, advisory, brokerage, planner-client, or any other professional relationship between you and Pord. or any of its founders, employees, contractors, or affiliates.</p>
      <p>Pord. is not acting as your investment adviser, broker-dealer, financial planner, attorney, accountant, or tax professional. Nothing in this experience should be interpreted as personalized financial guidance.</p>

      <h3>1.3 Assessment Limitations</h3>
      <p>The topics mentioned in the session are intended only to illustrate common behavioral finance topics and are not a clinical, psychological, neurological, or professional assessment of any kind.</p>
      <p>User result:</p>
      <ul>
        <li>Is not a formal risk tolerance assessment as defined by FINRA, the SEC, or any investment advisory standard.</li>
        <li>Is not a suitable basis for making any actual investment decision.</li>
        <li>May not reflect how you would behave in a real market event.</li>
        <li>Should not be relied upon by any financial adviser, planner, or institution as a formal investor profile.</li>
        <li>Is intended solely for reflection, education, and product demonstration purposes.</li>
      </ul>

      <h3>1.4 Research, Sources & Forward-Looking References</h3>
      <p>References to market driven actions, cognitive bias research, academic studies, public datasets, surveys, or third-party commentary are included for educational attribution and context only. They are illustrative, not predictive, and do not guarantee any outcome for any individual user.</p>
      <p>Pord. does not claim affiliation with, endorsement by, sponsorship from, or partnership with any cited institution, publication, academic author, or research source unless explicitly stated.</p>

      <h3>1.5 Consult a Qualified Professional</h3>
      <p>Before making any investment, tax, legal, retirement, or financial planning decision, consult a qualified and appropriately licensed professional who can evaluate your personal circumstances, goals, risk tolerance, liquidity needs, and time horizon.</p>

      <h2>Part 2 — Privacy Policy</h2>

      <h3>2.1 Who We Are</h3>
      <p>Pord. ("Pord.," "we," "us," or "our") is an educational investment platform currently in development. This Privacy Policy applies to the landing page at pordapp.com and the Capsule Scenario contained within it.</p>

      <h3>2.2 What We Collect</h3>
      <p>When you join the waitlist, we collect only three things:</p>
      <ul>
        <li>Name — to personalize communications</li>
        <li>Email address — for development updates and early access communications</li>
        <li>Module preference — one selection from three options, used for product development prioritization</li>
      </ul>
      <p>That is the full extent of personal information intentionally collected through the waitlist form.</p>

      <h3>2.3 What We Do Not Collect From the Capsule Scenario</h3>
      <p>The Capsule Scenario runs entirely within your browser session.</p>
      <ul>
        <li>Your answers are not sent to our servers</li>
        <li>Your "EXHALE" result is not stored by us</li>
        <li>Your "EXHALE" profile is not attached to your email submission</li>
        <li>We do not create a user dossier, scoring file, or personalized investment profile from your activity in the scenario</li>
      </ul>

      <h3>2.4 How We Use Your Information</h3>
      <p>We use your personal information only to:</p>
      <ul>
        <li>Notify you about updates on early access availability</li>
        <li>Send periodic Pord. development updates</li>
        <li>Understand broad module interest for product prioritization</li>
        <li>Respond to support, access, deletion, or privacy requests</li>
      </ul>
      <p>We do not sell, rent, license, or trade your personal information to any third party.</p>

      <h3>2.5 Data Sharing</h3>
      <p>We do not share your information with third parties for advertising, lead generation, profiling, or data brokerage. We may use service providers for website hosting, form processing, or email delivery. If we do, they process your data only for those limited purposes and not for their own marketing.</p>

      <h3>2.6 Data Retention & Deletion</h3>
      <p>We retain waitlist information only as long as reasonably necessary. You may request deletion at any time by emailing info@clarityjournalbyenquips.com. We will process requests within 7 business days.</p>

      <h3>2.7 Children's Privacy</h3>
      <p>Pord. is intended for adults 18 and older. We do not knowingly collect information from children under 13. If you believe a minor has submitted information, contact us and we will remove it promptly.</p>

      <h3>2.8 California Privacy Note</h3>
      <p>California residents may have rights under CCPA/CPRA, including the right to know, delete, or opt out of sale or sharing of personal information. Pord. does not sell personal information. See <Link to="/do-not-sell" className="ghost-link" style={{ textDecoration: "underline" }}>Do Not Sell</Link> for the full notice and opt-out process.</p>

      <h3>2.9 Policy Changes</h3>
      <p>We may update this Privacy Policy as the platform evolves. Material changes will be communicated via the website and by email to waitlist subscribers. The "Last Updated" date above will always reflect the most recent revision. Continued use constitutes acceptance of the updated policy.</p>

      <div style={{ marginTop: 60 }}>
        <Link to="/" className="cta-pill" data-testid="back-to-pord-btn">Back to Pord.</Link>
      </div>
    </div>
  );
}
